// import { createSchema } from "../../../../shared/lib/helpers/schema.helpers";
import { z } from "zod";
import { 
    workScopeStatusOptions,   
    ownerBuilderPermitStatusOptions,   
    buildingInspectionStatusOptions,
    residenceTypeOptions,
    structureTypeOptions,
    overallStatusOptions
} from "../../constants/options";
import { selectSchema, textSchema, claimedBySchema } from "../../../../shared/lib/schemas/common.schema";
import { makeOptional } from "../../../../shared/lib/helpers/schema.helpers";
import { yesNoType } from "@/shared/constants/options";

export const exteriorDoorInstallInfoFormSchema = z.object({
    exteriorDoorInstall: makeOptional(selectSchema(workScopeStatusOptions)),
    doorsReplacing: makeOptional(z.number()),
    doorsNeedTrim: makeOptional(z.number()),
    claimedBy: claimedBySchema,
    description: makeOptional(textSchema("lg")),
    goodwillExteriorDoorInstallOn: makeOptional(z.boolean()),
    goodwillExteriorDoorInstall: makeOptional(selectSchema(workScopeStatusOptions)),
    goodwillExteriorDoorInstallClaimedBy: claimedBySchema.optional(),
})

export const drivewayRepairFormSchema = z.object({
    drivewayRepair: makeOptional(selectSchema(workScopeStatusOptions)),
    drivewayRepairDescription: makeOptional(textSchema("lg")),
    drivewayClaimedBy: claimedBySchema,
    goodwillDrivewayRepairOn: makeOptional(z.boolean()),
    goodwillDrivewayRepair: makeOptional(selectSchema(workScopeStatusOptions)),
    goodwillDrivewayRepairClaimedBy: claimedBySchema.optional(),
})

export const stormShuttersFormSchema = z.object({
    shutterInstall: makeOptional(selectSchema(workScopeStatusOptions)),
    shuttersClaimedBy: claimedBySchema,
    shutterDescription: makeOptional(textSchema("lg")),
    goodwillShutterInstallOn: makeOptional(z.boolean()),
    goodwillShutterInstall: makeOptional(selectSchema(workScopeStatusOptions)),
    goodwillShutterInstallClaimedBy: claimedBySchema.optional(),
})

export const miscellaneousInfoFormSchema = z.object({
    miscellaneous: makeOptional(selectSchema(workScopeStatusOptions)),
    claimedBy: claimedBySchema,
    miscDescription: makeOptional(textSchema("lg")),
})

export const homeStatusInfoFormSchema = z.object({
    leadPaint: makeOptional(z.enum(["yes", "no"])),
    roofLeaking:makeOptional(z.string()),
    CurrentlyOccupied:makeOptional(z.string()),
    permissionToWork: makeOptional(z.enum(["yes", "no"])), 
    mediaWaiverSigned: makeOptional(z.enum(["yes", "no"])),
    helpWithinScope: makeOptional(z.enum(["yes", "no"])),
    workWaiverSigned: makeOptional(z.enum(["yes", "no"])),
    functionallyComplete: makeOptional(z.boolean()),
    fullyComplete: makeOptional(z.boolean()),
    overallStatus: makeOptional(selectSchema(overallStatusOptions)),
    primaryneeds: makeOptional(textSchema()),
    whereDamage:makeOptional(selectSchema(structureTypeOptions)),    
})

export const permitInspectionStatusInfoFormSchema = z.object({
    builderPermitStatus: makeOptional(selectSchema(ownerBuilderPermitStatusOptions)),
    roofingPermitNumber: makeOptional(textSchema()),
    permitApplicant: makeOptional(textSchema()),
    permitDescription: makeOptional(textSchema()),
    ownerBuilderPermitNumber: makeOptional(textSchema()),
    roofingInspections501: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    roofingInspections503: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    framingInspections105: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    insulationInspections107: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    plumbingInspections202: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    plumbingInspections204: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    electricalInspections304: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    electricalInspections305: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    hvacInspections401: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    hvacInspections402: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    shutterInspections125: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    finalInspection106: makeOptional(selectSchema(buildingInspectionStatusOptions)),
    drywallInspections: makeOptional(selectSchema(buildingInspectionStatusOptions)),
})
    
export const homeForm3Schema = z.object({
    exteriorDoorInstallInfo: exteriorDoorInstallInfoFormSchema.nullable(),
    miscellaneousInfo: miscellaneousInfoFormSchema.nullable(),
    drivewayRepair: drivewayRepairFormSchema.nullable(),
    stormShutters: stormShuttersFormSchema.nullable(),
    homeStatusInfo: homeStatusInfoFormSchema.nullable(),
    permitInspectionStatusInfo: permitInspectionStatusInfoFormSchema.nullable(),
}).partial()

export type HomeForm3Schema = z.infer<typeof homeForm3Schema>
